export const appVersion = `v. ${process.env?.REACT_APP_VERSION}`;
